export default function Submission() {
  this.submissionID = null
  this.certificationName = ''
  this.certificationPhone = ''
  this.certificationCompany = ''
  this.certificationTitle = ''
  this.certificationEmail = ''
  this.certificationComment = ''
  this.created = new Date()
  this.lastUpdated = new Date()
}